<div class="wrapper">
    <div class="badge rounded-pill custom-badge">
        <app-icon type="Globe"></app-icon>
        <span class="text"> {{ displayText }} <em class="es">ES</em> </span>
    </div>
</div>
